import { newFacture3Schema } from "../schemas.js";
const validateVentilationsOrRèglementsTotal = (ventilations, targetTotal) => {
    const total = ventilations.reduce((acc, v) => acc + v.montantCent, 0);
    return total === targetTotal;
};
export default (_facture) => {
    const result = newFacture3Schema.safeParse(_facture);
    const facture = result.data;
    if (!facture) {
        console.error("factureValidate: facture is not valid", result.error);
        return false;
    }
    if (facture.règlements.length > 0) {
        if (!validateVentilationsOrRèglementsTotal(facture.règlements, facture.montantCent)) {
            return false;
        }
    }
    if (facture.ventilations.length > 0 &&
        !validateVentilationsOrRèglementsTotal(facture.ventilations, facture.montantCent)) {
        return false;
    }
    if (facture.règlements.length > 0 &&
        facture.règlements.some((r) => r.ventilations.length > 0)) {
        if (!validateVentilationsOrRèglementsTotal(facture.règlements.flatMap((r) => r.ventilations), facture.montantCent)) {
            return false;
        }
    }
    return true;
};
//# sourceMappingURL=factureValidate.js.map